import { DataObject } from '@/utils/DataObject';
import { Pagination } from './Pagination';

export class PaginationTransformer {

  public toClass(data: DataObject = {}): Pagination {
    return new Pagination({
      currentPage: data.current_page,
      total: data.total,
      lastPage: data.last_page,
      perPage: data.per_page
    })
  }

}
